module.exports = __webpack_public_path__ + "static/media/MISSIONS.247beb5d.jpg";